import { useState, useEffect } from "react";
import { Card, Col, Row, Spinner } from "react-bootstrap";
import axios from "axios";
import { toast } from "react-toastify";
import { BASE_URL, HEADERS } from "../../utils/constant";
import AdminDetailsModal from "../../components/Modals/HisstoryModals/AdminDetailsModal";
import { FaUsers, FaCheckCircle, FaTimesCircle, FaClock } from "react-icons/fa";
import moment from "moment";
import { MdCancel, MdCheckCircle } from "react-icons/md";
import CustomSubscriptionModal from "../../components/Modals/CustomSubscriptionModal";

const DashboardWidget = ({ title, value, icon, onClick }) => (
  <Card
    className="h-100 rounded-lg shadow-sm d-flex w-100"
    style={{
      backgroundColor: "#fffbe6",
      border: "1px solid #f7e6a1",
      cursor: "pointer",
      transition: "transform 0.2s ease-in-out",
    }}
    onClick={onClick}
  >
    <Card.Body className="d-flex align-items-center p-2 gap-2 flex-wrap">
      <div
        className="rounded-circle d-flex justify-content-center align-items-center flex-shrink-0"
        style={{
          width: "40px",
          height: "40px",
          backgroundColor: "#ffedc2",
          color: "#6c757d",
          fontSize: "1.3rem",
        }}
      >
        {icon}
      </div>
      <div className="text-start text-break" style={{ minWidth: 0, flex: 1 }}>
        <h6
          className="card-title mb-1 text-truncate"
          style={{
            fontWeight: "500",
            fontSize: "0.9rem",
            color: "#343a40",
            maxWidth: "100%",
          }}
          title={title}
        >
          {title}
        </h6>
        <p
          className="card-text mb-0"
          style={{
            fontSize: "1.3rem",
            fontWeight: "600",
            color: "#343a40",
            wordBreak: "break-word",
          }}
        >
          {value}
        </p>
      </div>
    </Card.Body>
  </Card>
);
const SuperAdminDashboard = () => {
  const [admins, setAdmins] = useState([]);
  const [loading, setLoading] = useState(false);
  const [selectedAdminId, setSelectedAdminId] = useState(null);
  const [showDetailsModal, setShowDetailsModal] = useState(false);
  const [showCustomModal, setShowCustomModal] = useState(false);

  const fetchAdmins = async () => {
    try {
      setLoading(true);
      const response = await axios.get(
        `${BASE_URL}/users/tms_users/all_admins`,
        {
          headers: HEADERS,
        },
      );
      if (response.status === 200) setAdmins(response.data || []);
      else toast.error("Failed to fetch admin data");
    } catch (error) {
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchAdmins();
  }, []);

  const handleAdminClick = (id) => {
    setSelectedAdminId(id);
    setShowDetailsModal(true);
  };
  const totalAdmins = admins.length;
  const activeAdmins = admins.filter((a) => a.is_active).length;
  const inactiveAdmins = totalAdmins - activeAdmins;
  const trialAdmins = admins.filter((a) => a.subscription === 10).length;

  const handleToggleActive = async (adminId, currentStatus) => {
    try {
      const response = await axios.put(
        `${BASE_URL}/users/tms_users/${adminId}/`,
        { is_active: !currentStatus },
        {
          headers: {
            ...HEADERS,
            "Content-Type": "application/json",
          },
        },
      );
      if (response.status === 200) {
        toast.success(
          `Admin ${currentStatus ? "deactivated" : "activated"} successfully!`,
        );
        fetchAdmins();
      }
    } catch (error) {
      if (error.response && error.response.data && error.response.data.error) {
        const errorData = error.response.data.error;

        if (typeof errorData === "object" && !Array.isArray(errorData)) {
          Object.entries(errorData).forEach(([field, messages]) => {
            if (Array.isArray(messages)) {
              messages.forEach((message) => {
                toast.error(`${message}`);
              });
            } else {
              toast.error(`${messages}`);
            }
          });
        } else {
          toast.error("Unexpected error format. Please try again.");
        }
      } else {
        toast.error("Error Please Try again.");
      }
    }
  };

  return (
    <div className="container-fluid py-3">
      <Row className="mb-3">
        <Col>
          <h4 className="fw-bold text-dark">Super Admin Dashboard</h4>
          <p className="text-muted mb-0">Overview of all registered admins</p>
        </Col>
      </Row>
      <Row className="g-3 mb-4">
        <Col xs={12} sm={6} md={4} lg={3}>
          <DashboardWidget
            title="Total Admins"
            value={totalAdmins}
            icon={<FaUsers />}
          />
        </Col>
        <Col xs={12} sm={6} md={4} lg={3}>
          <DashboardWidget
            title="Active Admins"
            value={activeAdmins}
            icon={<FaCheckCircle />}
          />
        </Col>
        <Col xs={12} sm={6} md={4} lg={3}>
          <DashboardWidget
            title="Inactive Admins"
            value={inactiveAdmins}
            icon={<FaTimesCircle />}
          />
        </Col>
        <Col xs={12} sm={6} md={4} lg={3}>
          <DashboardWidget
            title="On Trial"
            value={trialAdmins}
            icon={<FaClock />}
          />
        </Col>
      </Row>

      <Card className="shadow-sm border-0" style={{ borderRadius: "10px" }}>
        <Card.Body>
          <h5 className="fw-semibold mb-3 text-dark">Admin Details</h5>

          {loading ? (
            <div className="text-center py-4">
              <Spinner animation="border" />
            </div>
          ) : admins.length === 0 ? (
            <div className="text-center text-muted py-4">No admins found.</div>
          ) : (
            <div
              className="inventory-table-wrapper"
              style={{ overflowX: "auto" }}
            >
              <table
                className="inventory-table"
                style={{ width: "100%", borderCollapse: "collapse" }}
              >
                <thead
                  style={{
                    backgroundColor: "#fffbe6",
                    borderBottom: "2px solid #f7e6a1",
                  }}
                >
                  <tr>
                    <th>#</th>
                    <th>ID</th>
                    <th>Name</th>
                    <th>Email</th>
                    <th>Company</th>
                    <th>Industry</th>
                    <th>Phone</th>
                    <th>Plan</th>
                    <th>User Limit</th>
                    <th>SMS Limit</th>

                    <th>Status</th>
                    <th>Start Date</th>
                    <th>End Date</th>
                    <th>Joined On</th>
                    <th></th>
                  </tr>
                </thead>
                <tbody>
                  {admins.map((admin, idx) => (
                    <tr
                      key={idx}
                      onClick={() => handleAdminClick(admin.id)}
                      style={{
                        cursor: "pointer",
                        transition: "background-color 0.2s",
                      }}
                      onMouseEnter={(e) =>
                        (e.currentTarget.style.backgroundColor = "#fff8dc")
                      }
                      onMouseLeave={(e) =>
                        (e.currentTarget.style.backgroundColor = "transparent")
                      }
                    >
                      <td>{idx + 1}</td>
                      <td>{admin.id}</td>
                      <td>{`${admin.first_name || ""} ${
                        admin.last_name || ""
                      }`}</td>
                      <td>{admin.email || "—"}</td>
                      <td>{admin.company_name || "—"}</td>
                      <td>{admin.industry_type || "—"}</td>
                      <td>{admin.phone_number || "—"}</td>
                      <td>{admin.subscription?.plan || "—"}</td>

                      <td>{admin.subscription?.user_limit || "—"}</td>

                      <td>{admin.subscription?.sms_limit || "—"}</td>

                      <td>{admin.subscription?.status || "—"}</td>

                      <td>
                        {admin.subscription?.subscription_start_date
                          ? moment(
                              admin.subscription.subscription_start_date,
                            ).format("DD-MM-YYYY")
                          : admin.subscription?.trial_start_date
                            ? moment(
                                admin.subscription.trial_start_date,
                              ).format("DD-MM-YYYY")
                            : "—"}
                      </td>
                      <td>
                        {admin.subscription?.subscription_end_date
                          ? moment(
                              admin.subscription.subscription_end_date,
                            ).format("DD-MM-YYYY")
                          : admin.subscription?.trial_end_date
                            ? moment(admin.subscription.trial_end_date).format(
                                "DD-MM-YYYY",
                              )
                            : "—"}
                      </td>
                      <td>
                        {admin.created_at
                          ? moment(admin.created_at).format("DD-MM-YYYY")
                          : "—"}
                      </td>
                      <td>
                        <div className="d-flex gap-2 justify-content-end">
                          <button
                            className={`btn btn-sm ${
                              admin.is_active ? "btn-danger" : "btn-success"
                            }`}
                            onClick={(e) => {
                              e.stopPropagation();
                              handleToggleActive(admin.id, admin.is_active);
                            }}
                          >
                            {admin.is_active ? "Deactivate" : "Activate"}
                          </button>

                          <button
                            className="btn btn-sm btn-primary"
                            onClick={(e) => {
                              e.stopPropagation();
                              setSelectedAdminId(admin.id);
                              setShowCustomModal(true);
                            }}
                          >
                            Custom Plan
                          </button>
                        </div>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}
        </Card.Body>
      </Card>

      {showDetailsModal && (
        <AdminDetailsModal
          show={showDetailsModal}
          onHide={() => setShowDetailsModal(false)}
          adminId={selectedAdminId}
          fetchAdmins={fetchAdmins}
        />
      )}
      {showCustomModal && (
        <CustomSubscriptionModal
          show={showCustomModal}
          onHide={() => setShowCustomModal(false)}
          adminId={selectedAdminId}
        />
      )}
    </div>
  );
};

export default SuperAdminDashboard;
